import React from "react";
import "../samle.css";

export const MarqueePlain = () => {
  const icons = ["HTML", "CSS", "JavaScript", "Typescript"];

  return (
    <div className="app">
      <div className="marquee">
        <div className="marquee-content">
          {icons.map((icon, index) => (
            <div className="icon-wrapper" key={index}>
              <p>{icon}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
